module.exports = __webpack_public_path__ + "img/eye_hut.prt.ea9f2681.jpg";